/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateRealEstateCommandDto } from './UpdateRealEstateCommandDto';
import {
    UpdateRealEstateCommandDtoFromJSON,
    UpdateRealEstateCommandDtoFromJSONTyped,
    UpdateRealEstateCommandDtoToJSON,
    UpdateRealEstateCommandDtoToJSONTyped,
} from './UpdateRealEstateCommandDto';
import type { SaveAnswerCommandDto } from './SaveAnswerCommandDto';
import {
    SaveAnswerCommandDtoFromJSON,
    SaveAnswerCommandDtoFromJSONTyped,
    SaveAnswerCommandDtoToJSON,
    SaveAnswerCommandDtoToJSONTyped,
} from './SaveAnswerCommandDto';

/**
 * 
 * @export
 * @interface UpdateRealEstateWithQuestionsCommandDto
 */
export interface UpdateRealEstateWithQuestionsCommandDto {
    /**
     * 
     * @type {UpdateRealEstateCommandDto}
     * @memberof UpdateRealEstateWithQuestionsCommandDto
     */
    updateRealEstateCommand: UpdateRealEstateCommandDto;
    /**
     * 
     * @type {SaveAnswerCommandDto}
     * @memberof UpdateRealEstateWithQuestionsCommandDto
     */
    saveAnswersCommand: SaveAnswerCommandDto;
}

/**
 * Check if a given object implements the UpdateRealEstateWithQuestionsCommandDto interface.
 */
export function instanceOfUpdateRealEstateWithQuestionsCommandDto(value: object): value is UpdateRealEstateWithQuestionsCommandDto {
    if (!('updateRealEstateCommand' in value) || value['updateRealEstateCommand'] === undefined) return false;
    if (!('saveAnswersCommand' in value) || value['saveAnswersCommand'] === undefined) return false;
    return true;
}

export function UpdateRealEstateWithQuestionsCommandDtoFromJSON(json: any): UpdateRealEstateWithQuestionsCommandDto {
    return UpdateRealEstateWithQuestionsCommandDtoFromJSONTyped(json, false);
}

export function UpdateRealEstateWithQuestionsCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRealEstateWithQuestionsCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'updateRealEstateCommand': UpdateRealEstateCommandDtoFromJSON(json['updateRealEstateCommand']),
        'saveAnswersCommand': SaveAnswerCommandDtoFromJSON(json['saveAnswersCommand']),
    };
}

export function UpdateRealEstateWithQuestionsCommandDtoToJSON(json: any): UpdateRealEstateWithQuestionsCommandDto {
    return UpdateRealEstateWithQuestionsCommandDtoToJSONTyped(json, false);
}

export function UpdateRealEstateWithQuestionsCommandDtoToJSONTyped(value?: UpdateRealEstateWithQuestionsCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updateRealEstateCommand': UpdateRealEstateCommandDtoToJSON(value['updateRealEstateCommand']),
        'saveAnswersCommand': SaveAnswerCommandDtoToJSON(value['saveAnswersCommand']),
    };
}

